import { graphql, useStaticQuery } from "gatsby";

export  const FormTallerAprendizajeRegionesQuery = () => {
    const data = useStaticQuery(graphql`
        query contentfulFormTallerAprendizajeRegiones {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "7LbQZyvEPpS62FtJ4srf69" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            textoTerminosMigrantes {
                                raw
                            }
                            obligatorio
                            seccion
                            tabOrder
                            ayuda
                            placeholder
                        }
                        tituloBoton
                    }
                }
            }
            # Tiene Empleo y sin interes en talleres - modal de AMVA
            modalSuccessVacantes: allContentfulContactenos(
                filter: { contentful_id: { eq: "4TqOl3pWkrBavajmYXMtth" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "4dNZ8KMgClru4JWuwuFHsL" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalSuccessTallerCursos: allContentfulContactenos(
                filter: { contentful_id: { eq: "491VzmBteN0YFD7kxLo2iH" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                    auxText
                }
            }
            # VALIDAR PARA ELIMINAR
            pantallaSinInteresConEmpleo: allContentfulContactenos(
                filter: {contentful_id: {eq: "2OiNdFEOBvadFLiqDmNIfV"}}
            ) {
                nodes {
                    contentful_id
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    descripcionFormulario{
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                }
            }
            pantallaConInteresConEmpleo: allContentfulContactenos(
                filter: {contentful_id: {eq: "2VJpN0uXaQN571JTp3FcO0"}}
            ) {
                nodes {
                    contentful_id
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                }
            }
            pantallaSinInteresSinEmpleo: allContentfulContactenos(
                filter: {contentful_id: {eq: "2YAQiCts8Kx2CrOzxpcbYI"}}
            ) {
                nodes {
                    contentful_id
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    descripcionFormulario{
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                }
            }
            pantallaRegistroDuplicado: allContentfulContactenos(
                filter: {contentful_id: {eq: "2pjAkHIOOh9zQbhCsCRJdq"}}
            ) {
                nodes {
                    contentful_id
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                }
            }
            modalWithoutAge: allContentfulContactenos(
                filter: { contentful_id: { eq: "2MCMN2vRDLfvotbMmnLVgy" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
        }
    `);
    return data;
}  